// extracted by mini-css-extract-plugin
export var active = "_cn-2";
export var recordingDot = "_cn-1";
export var recordingIndicator = "_cn-0";